var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticStyle: { "padding-top": "50px", "min-height": "90vh" } },
    [
      _c(
        "div",
        {
          staticStyle: {
            padding: "5px 16px",
            color: "#CCC",
            "font-size": "75%"
          }
        },
        [_vm._v("分类")]
      ),
      _vm._v(" "),
      _c("MobileTicketTypePicker", {
        ref: "TypePicker",
        model: {
          value: _vm.ticketNew.orderType,
          callback: function($$v) {
            _vm.$set(_vm.ticketNew, "orderType", $$v)
          },
          expression: "ticketNew.orderType"
        }
      }),
      _vm._v(" "),
      _vm.showTitle
        ? [
            _c(
              "div",
              {
                staticStyle: {
                  padding: "5px 16px 0 16px",
                  color: "#CCC",
                  "font-size": "75%"
                }
              },
              [_vm._v("主题")]
            ),
            _vm._v(" "),
            _c("van-field", {
              staticStyle: { "font-size": "110%" },
              attrs: { placeholder: "主题和内容不可同时为空" },
              model: {
                value: _vm.ticketNew.orderTitle,
                callback: function($$v) {
                  _vm.$set(_vm.ticketNew, "orderTitle", $$v)
                },
                expression: "ticketNew.orderTitle"
              }
            })
          ]
        : _vm._e(),
      _vm._v(" "),
      _c(
        "div",
        {
          staticStyle: {
            padding: "5px 16px 0 16px",
            color: "#CCC",
            "font-size": "75%"
          }
        },
        [_vm._v("内容")]
      ),
      _vm._v(" "),
      _c("van-field", {
        staticStyle: {
          "font-size": "110%",
          "max-height": "65px",
          overflow: "auto"
        },
        attrs: {
          type: "textarea",
          maxlength: "999",
          "show-word-limit": "",
          rows: "2",
          autosize: "",
          placeholder: "描述你遇到的问题"
        },
        model: {
          value: _vm.ticketNew.orderContent,
          callback: function($$v) {
            _vm.$set(_vm.ticketNew, "orderContent", $$v)
          },
          expression: "ticketNew.orderContent"
        }
      }),
      _vm._v(" "),
      _c(
        "div",
        { staticStyle: { padding: "10px" } },
        [
          _c("MobileTicketUpload", { ref: "up6" }),
          _vm._v(" "),
          _c(
            "MobileSubmitButton",
            { ref: "subBtn_1", on: { click: _vm.newTicket_1 } },
            [_vm._v("提交")]
          )
        ],
        1
      ),
      _vm._v(" "),
      _c("div", { staticStyle: { height: "15vh" } })
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-09b247fa", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-09b247fa","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/mobile-ticket/MobileTicketNew.vue
// module id = 632
// module chunks = 75